import React from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from 'common/helmets/Helmet';

const Title = 'Pallyy Case Study | Canny';
const Description = 'How Canny helps Pallyy save time and shape their roadmap';
const Image = 'https://canny.io/images/c4433b983deeb70c0a43cbe5bb475b6e.jpg';
const PallyyUrl = 'https://canny.io/case-studies/pallyy';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${PallyyUrl}#webpage`,
    url: PallyyUrl,
    name: 'Case Study: Pallyy × Canny',
    description: 'How Canny helps Pallyy save time and shape their roadmap.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${PallyyUrl}#article`,
    genre: 'Case Study',
    headline: 'How Canny helps Pallyy save time and shape their roadmap',
    description:
      "As a solo founder serving 1.4k paying and 60k free users, Tim Bennetto needed an efficient feedback system. By embedding Canny boards directly into Pallyy's dashboard, feedback began flowing in automatically. With public roadmaps and changelogs, Pallyy's users stay informed—saving countless hours previously spent on cold emails.",
    inLanguage: 'en',
    url: PallyyUrl,
    mainEntityOfPage: { '@id': `${PallyyUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Pallyy', url: 'https://pallyy.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Pallyy', item: PallyyUrl },
  ]),
]);

const PallyyLandingHelmet = ({ ...props }) => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: PallyyUrl },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
      {...props}>
      <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
    </Helmet>
  );
};

export default PallyyLandingHelmet;
